import { MUI_DATE_PICKER_ES_LOCALE_TEXT } from '../../components/constants/muiDatePickerEsLocaleText'
import {
  UI_COLOR_ACCENT_ORANGE,
  UI_COLOR_ACCENT_ORANGE_ALT_HOVER,
  UI_COLOR_DANGER,
  UI_COLOR_PRIMARY,
  UI_COLOR_PRIMARY_HOVER,
  UI_COLOR_SUCCESS,
  UI_COLOR_TEXT_SUBTITLE
} from '../../constants/uiColors'

export const DEPOSIT_BALANCED_COLOR = UI_COLOR_SUCCESS
export const EDITABLE_INPUT_HEIGHT = 41
export const DEPOSIT_DIALOG_INPUT_HEIGHT = 40
export const DEPOSIT_NUMBER_MAX_LENGTH = 24
export const ACTION_COLUMN_WIDTH = 50
export const LIQUIDATION_DETAILS_GRID_COLUMNS = { xs: '1fr', md: 'repeat(3, minmax(0, 1fr))' }

export const DEPOSIT_DIALOG_ERROR_TEXT_SX = {
  color: UI_COLOR_DANGER,
  fontSize: 10,
  lineHeight: '14px'
}

export const DEPOSIT_DIALOG_BANK_PLACEHOLDER = 'Busque o seleccione'
export const DEPOSIT_DIALOG_NUMBER_PLACEHOLDER = 'Ej. 69267313'
export const DEPOSIT_DIALOG_AMOUNT_PLACEHOLDER = '0.00'
export const DEPOSIT_DIALOG_DATE_LOCALE_TEXT = {
  ...MUI_DATE_PICKER_ES_LOCALE_TEXT,
  fieldDayPlaceholder: () => 'dd',
  fieldMonthPlaceholder: () => 'mm',
  fieldYearPlaceholder: () => 'yyyy'
}

export const DISCARD_DIALOG_CONFIRM_BUTTON_SX = {
  backgroundColor: UI_COLOR_ACCENT_ORANGE,
  '&:hover': {
    backgroundColor: UI_COLOR_ACCENT_ORANGE_ALT_HOVER,
    boxShadow: 'none'
  }
}

export const DELETE_DIALOG_PAPER_SX = { maxWidth: 550 }
export const DELETE_DIALOG_TITLE_SX = {
  px: { xs: 2.5, sm: 3 },
  py: 2,
  fontSize: { xs: 20, sm: 20 },
  fontWeight: 600,
  lineHeight: 1.2
}
export const DELETE_DIALOG_CONTENT_SX = { px: { xs: 2.5, sm: 3 }, pt: 2, pb: 1.5 }
export const DELETE_DIALOG_MESSAGE_SX = {
  mt: 1.5,
  color: UI_COLOR_TEXT_SUBTITLE,
  fontSize: { xs: 15, sm: 15 },
  lineHeight: 1.35
}
export const DELETE_DIALOG_ACTIONS_SX = { px: { xs: 2.5, sm: 3 }, pt: 1.5, pb: 2 }
export const DELETE_DIALOG_CANCEL_BUTTON_SX = {
  flex: { xs: 1, sm: '0 0 120px' },
  minHeight: 40,
  height: 40,
  px: 1.5,
  fontSize: 12,
  borderWidth: 1,
  borderColor: '#aaa5a5',
  color: '#9e9e9e',
  '&:hover': {
    borderWidth: 1,
    borderColor: '#969696',
    backgroundColor: '#fafafa',
    boxShadow: 'none'
  }
}
export const DELETE_DIALOG_CONFIRM_BUTTON_SX = {
  flex: { xs: 1, sm: '0 0 180px' },
  minHeight: 40,
  height: 40,
  px: 1.5,
  fontSize: 12,
  backgroundColor: UI_COLOR_PRIMARY,
  '&:hover': { backgroundColor: UI_COLOR_PRIMARY_HOVER, boxShadow: 'none' }
}
